import { useConditionStore } from "../condition/conditions.store";
import type { RequirementItem } from "./RequirementItem";

export function getRequirementCopyData(
  requirement: RequirementItem
) {
  const data = [];

  data.push(requirement);

  const conditionStore = useConditionStore();
  const conditions = conditionStore.getBySource(requirement);
  for (const condition of conditions) {
    data.push(condition);
  }

  return data;
}
